export default __webpack_public_path__ + "static/media/Eric Lam.04e63646.png";